import {DoctorDto} from "@apiModels/DoctorDto.csharp";
import {LocationDto} from "@apiModels/LocationDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";

function isServiceAvailableForDoctor(serviceId: string, doctor: DoctorDto): boolean {
    return !doctor.services.length || doctor.services.some((service) => service === serviceId);
}

function isServiceAvailableForLocation(service: ServiceContainerDto, location: LocationDto): boolean {
    return !location.specializations.length || location.specializations.some((specialization) => specialization === service.specializationId)
}

export function isQuickBookingAvailable(service: ServiceContainerDto, doctor: DoctorDto, location: LocationDto) {
    return !!service.id && isServiceAvailableForDoctor(service.id, doctor) && isServiceAvailableForLocation(service, location);
}